import { apiRequest } from "./client";

/**
 * NestJS Inbox contract (Part 72 §72.4):
 * - GET   /api/inbox/conversations?status=&assigneeId=&page=
 * - GET   /api/inbox/conversations/:id/messages?before=&page=
 * - POST  /api/inbox/conversations/:id/messages  {content, templateName?}
 * - PATCH /api/inbox/conversations/:id           {assignedUserId?, status?}
 * - POST  /api/inbox/conversations/:id/read      → { ok: true } (clears unread)
 * - GET   /api/inbox/templates
 */
export const inboxApi = {
  conversations: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.status && params.status !== "all") query.set("status", params.status);
    if (params.assigneeId && params.assigneeId !== "all") query.set("assigneeId", params.assigneeId);
    query.set("page", String(params.page ?? 1));
    query.set("size", String(params.size ?? 50));
    const data = await apiRequest(`/api/inbox/conversations?${query}`);
    return {
      items: (data?.items || []).map((t) => ({
        ...t,
        lastMessageAtUtc: t.lastMessageAtUtc ?? null,
        businessHours: t.businessHours ?? data?.businessHours ?? null,
      })),
      // Sprint 9 (Part 89 §89.5): org-wide business-hours state for badges.
      businessHours: data?.businessHours ?? null,
    };
  },
  messages: async (conversationId, params = {}) => {
    const query = new URLSearchParams();
    query.set("page", String(params.page ?? 1));
    query.set("size", String(params.size ?? 50));
    const data = await apiRequest(`/api/inbox/conversations/${conversationId}/messages?${query}`);
    // Sprint 15 QA: backend sorts newest-first; the chat renders oldest-first.
    return (data?.items || []).map((m) => ({ ...m })).reverse();
  },
  send: (conversationId, payload) =>
    apiRequest(`/api/inbox/conversations/${conversationId}/messages`, {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  update: (conversationId, payload) =>
    apiRequest(`/api/inbox/conversations/${conversationId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    }),
  markRead: (conversationId) =>
    apiRequest(`/api/inbox/conversations/${conversationId}/read`, { method: "POST" }),
  templates: async () => {
    const data = await apiRequest("/api/inbox/templates");
    return (data?.items || []).map((t) => ({ ...t }));
  },
};
